<div class="form-fields">
  {{#each groups}}
    <div class="field-input-group {{#if template_option}}--{{template_option}}{{/if}}" data-group="field-input-group">
      {{#if label}}
        <div class="field-input-group__label" data-group="field-input-group-label">{{label}}</div>
      {{/if}}
      {{#each fields}}
        <div class="field-input {{type}} {{#if size}}--size-{{size}}{{/if}}">
          {{> (fbPartial . "type") prefix="patient_journey_task[tool_payload]" }}
        </div>
      {{/each}}
    </div>
  {{/each}}
</div>
